import React from 'react'
import { Link } from '@tanstack/react-router'
import { Button, Tag, Tooltip, Typography } from 'antd'
import { ArrowLeftOutlined, SettingOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/page-header'
import { Site } from '../site'
import { SiteHealth } from './site-health'

export type SiteHeaderProps = {
    site: Site
    /** In the settings: show a link back to the chats instead of the settings link. */
    backToChats?: boolean
}

export function SiteHeader({ site, backToChats = false }: SiteHeaderProps) {
    const { t } = useTranslation()
    const label = t(backToChats ? 'Back to chats' : 'Settings')

    return (
        <PageHeader
            className="mb-4"
            title={site.name}
            suffix={
                <>
                    <Typography.Link
                        href={site.url}
                        target="_blank"
                        rel="noreferrer"
                        type="secondary"
                    >
                        {site.host}
                    </Typography.Link>
                    {site.connected ? <SiteHealth health={site.health} /> : <Tag>{t('Disconnected')}</Tag>}
                </>
            }
        >
            <Tooltip title={label}>
                <Link
                    to={backToChats ? '/websites/$siteId' : '/websites/$siteId/settings'}
                    params={{ siteId: site.id }}
                    aria-label={label}
                    className="mt-0.5"
                >
                    <Button
                        type="text"
                        size="small"
                    >
                        {backToChats ? (
                            <ArrowLeftOutlined className="text-lg" />
                        ) : (
                            <SettingOutlined className="text-lg" />
                        )}
                    </Button>
                </Link>
            </Tooltip>
        </PageHeader>
    )
}
